import {
  useMutation,
  useMutationState,
  useQueryClient,
} from "@tanstack/react-query";

import { errorToast } from "@/shared/ui";
import { consultationsQueriesStore, scheduleAppointment } from "../api";

const mutationKey =
  consultationsQueriesStore.consultations.appointments.queryKey;

export const useScheduleAppointment = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationKey,
    mutationFn: scheduleAppointment,
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: consultationsQueriesStore.consultations.appointments.queryKey,
      });
    },
    onError: errorToast,
  });

  const isMutationSuccessful = Boolean(
    useMutationState({
      filters: {
        mutationKey,
        status: "success",
      },
    }).length,
  );

  return { mutation, isMutationSuccessful };
};
